import {
  FileTypes,
  SUPPORTED_FILE_EXTENSIONS,
} from '../../../utils/constants/global-constants'
import { mpfRListsHttp } from '../api/mpf-r-lists-http'

interface Files {
  fileName: string
  folderName: string
  metadata: { [s: string]: unknown } | ArrayLike<unknown>
}
function getFileExtension(fileName: string) {
  return fileName.split('.').pop()
}

function getFileType(fileName: string) {
  const extension = fileName.split('.').pop()
  return extension ? FileTypes[extension] : ''
}
const fileReturnType = (productMap) => {
  for (const [key, value] of productMap) {
    if (key === 'type') {
      return value
    }
  }
}
const callFiles = (item, filesList, ItemGUID, listName: string) => {
  const fileDetails = filesList?.filter((comment) => {
    return comment.fileName === item.fileName
  })
  const file = fileDetails[0]
  openFile(file, ItemGUID, listName)
}
async function openFile(
  file: Files,
  ekey: string,
  listName: string
): Promise<void> {
  if (file) {
    const extension = getFileExtension(file?.fileName)
    const list = await mpfRListsHttp().getList(listName)
    await list
      .blobs()
      .getContent(ekey, file?.fileName, file?.folderName)
      .then(function (data) {
        const metadataMap =
          file?.metadata instanceof Map
            ? file?.metadata
            : new Map(Object.entries(file?.metadata))
        let filetype = fileReturnType(metadataMap)
        if (filetype === undefined || filetype === '') {
          filetype = getFileType(file?.fileName)
        }
        const blob = new Blob([data], { type: filetype })
        const blobURL = window.URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL

        if (extension && SUPPORTED_FILE_EXTENSIONS.includes(extension)) {
          tempLink.setAttribute('download', file?.fileName)
        } else {
          tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(blobURL)
        }, 100)
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
async function openSpecificFile(
  file: Files,
  ekey: string,
  listName: string
): Promise<void> {
  if (file) {
    const extension = getFileExtension(file?.fileName)
    const list = await mpfRListsHttp().getList(listName)
    await list
      .blobs()
      .getContent(ekey, file?.fileName, file?.folderName)
      .then(function (data) {
        const metadataMap =
          file?.metadata instanceof Map
            ? file?.metadata
            : new Map(Object.entries(file?.metadata))
        let filetype = fileReturnType(metadataMap)
        if (filetype === undefined || filetype === '') {
          filetype = getFileType(file?.fileName)
        }
        const blob = new Blob([data], { type: filetype })
        const blobURL = window.URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL

        if (extension && SUPPORTED_FILE_EXTENSIONS.includes(extension)) {
          tempLink.setAttribute('download', file?.fileName)
        } else {
          tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(blobURL)
        }, 100)
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
export { callFiles, fileReturnType, getFileExtension, getFileType, openFile }
